export default {
  methods: {
    mxDebounce(timeoutId, func, delayTime = 300) {
      clearTimeout(timeoutId)
      return setTimeout(func, delayTime)
    },
  },
}
